export const FILES_ACCEPTED = 'image/*, application/pdf';

export const COUNT = {
  SINGLE: 1,
  PLURAL: 2
};
